import BaseModule from '@/store/baseModule';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['requests', 'pause_reason'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.P2C_BASE_URI}/requests/pause_reason`,
        }),
      }),
      makeQueryParams: makeListRequest({}),
      attributesObj: {
        is_valid: {
          serverSide: true,
          values: ['O'],
        },
      },
    })
  );

  store.dispatch('requests/pause_reason/setItemsPageSize', 3);
};
